import { Stamp } from "@scribenote/brian-design-system";
import type { ViewStatus } from "@views/viewsClient";

const CONFIG: Record<Exclude<ViewStatus, "open">, { label: string }> = {
  signed: { label: "Signed" },
};

/**
 * A view's sign-off mark (WEB-3247). `open` views are still live-updating and
 * carry no mark; `signed` is the locked, superseded-on-change state worth
 * surfacing on the view and its card. A sign-off is a mark a person left, so
 * it wears the approval stamp, not a computed-status highlighter.
 */
export const ViewLifecycleBadge = ({
  status,
  size = "sm",
}: {
  status: ViewStatus;
  size?: "sm" | "md";
}) => {
  if (status === "open") return null;
  const { label } = CONFIG[status];
  return (
    <Stamp
      tone="accent"
      data-testid={`view-status-${status}`}
      className={size === "md" ? "text-[0.75rem]" : undefined}
    >
      {label}
    </Stamp>
  );
};
